import { render } from "./SearchDropdown.vue?vue&type=template&id=b5f9e7bc&scoped=true"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"

import "./SearchDropdown.vue?vue&type=style&index=0&id=b5f9e7bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5f9e7bc"

export default script